import * as actionTypes from "../actions/actionTypes";

const initialState = {
  token: null,
  username: null,
  authError: null,
  loading: false,
  requiresTwoFactor: false,
  twoFactorUserId: null,
  redirectUrl: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return {
        ...state,
        loading: true,
        authError: null
      };

    case actionTypes.AUTH_SUCCESS:
      return {
        ...state,
        token: action.token,
        username: action.username,
        authError: null,
        loading: false,
        requiresTwoFactor: false,
        twoFactorUserId: null,
        redirectUrl: null
      };

    case actionTypes.AUTH_FAIL:
      return {
        ...state,
        authError: action.error,
        loading: false
      };

    case actionTypes.AUTH_LOGOUT:
      return {
        ...initialState
      };

    case actionTypes.AUTH_REQUIRES_2FA:
      return {
        ...state,
        requiresTwoFactor: true,
        twoFactorUserId: action.userId,
        redirectUrl: action.redirectUrl,
        loading: false,
        authError: null
      };

    case actionTypes.AUTH_2FA_START:
      return {
        ...state,
        loading: true,
        authError: null
      };

    default:
      return state;
  }
};

export default reducer;
